module.exports = __webpack_public_path__ + "static/photo15-a80d34df9ab43558b3ce6719cb923da9.png";